import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  reassignCollector: '',
  isExportModalOpen: false,
};

const recordsTableSlice = createSlice({
  name: 'recordsTable',
  initialState,
  reducers: {
    setReassignCollector(state, action) {
      state.reassignCollector = action.payload;
    },
    setExportModalOpen(state, action) {
      state.isExportModalOpen = action.payload;
    },
  },
});

export const { setReassignCollector, setExportModalOpen } = recordsTableSlice.actions;

export const selectRecordsTableReassignCollector = (state) =>
  state.recordsTable.reassignCollector;
export const selectRecordsTableExportModalOpen = (state) =>
  state.recordsTable.isExportModalOpen;

export default recordsTableSlice.reducer;
